export default __webpack_public_path__ + "static/media/b&a-woman2.04c8f01c.png";